export interface IKeyValue {
    id: number;
    name: string;
}

export interface IKeyDoubleValue extends IKeyValue {
  emailType: string;
}

export interface IKeyValueForm {
  name: string;
}

export interface IKeyDoubleValueForm extends IKeyValueForm {
  emailType: string;
}

export interface IKeyValueNumeric {
    key: string;
    value: number;
}

export interface IKeyValueQueryResult {
    totalItems: number;
    page: number;
    pageSize: number;
    totalPages: number;
    items: IKeyValue[];
}

export interface IKeyDoubleValueQueryResult {
  totalItems: number;
    page: number;
    pageSize: number;
    totalPages: number;
    items: IKeyDoubleValue[];
}


export function sortIKeyValueById(a: IKeyValue, b: IKeyValue) {
    if (a.id > b.id) return 1;
    if (b.id > a.id) return -1;
    return 0;
}

export function sortIKeyValueByName(a: IKeyValue, b: IKeyValue) {
    // Use toUpperCase() to ignore character casing
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
        comparison = 1;
    } else if (nameA < nameB) {
        comparison = -1;
    }
    return comparison;
}


export interface CodeValue {
  id: string;
  name: string;
}

export interface CodeValueQueryResult {
  totalItems: number;
  page: number;
  pageSize: number;
  totalPages: number;
  items: CodeValue[];
}
